export const COOKIE = {
  DURATION: 365,
  CACHE_DURATION: 90
}